import { create } from 'zustand';

interface NavMenuState {
  isVisible: boolean;
  setVisibility: (isVisible: boolean) => void;
  toggleVisibility: () => void;
}

export const useNavMenuStore = create<NavMenuState>((set) => ({
  isVisible: true,
  setVisibility: (isVisible) => set({ isVisible }),
  toggleVisibility: () => set((state) => ({ isVisible: !state.isVisible })),
}));
